<template>
<v-container class="fill-height data-container" fluid>

    <div class="data-table-container">

        <v-data-table dense v-model="selectedSites" :item-class="setRowColor" @input="inputChanged" :footer-props="footerProps" sort-by="selected" sort-desc :headers="headers" :items="$props.allSitesList" item-key="site_id" :search="searchText" show-select :items-per-page="250" class="sites-data-table" height="calc(100vh - 350px)" fixed-header multi-sort>
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title style="font-weight: bold;">Site List</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-text-field v-model="searchText" append-icon="mdi-magnify" color="#c42111" label="Site Search" single-line hide-details></v-text-field>
                </v-toolbar>
            </template>
        </v-data-table>

    </div>

</v-container>
</template>

<script>
export default {
    name: 'ThresholdProfileSiteSelect',
    props: ['allSitesList', 'selectedSitesIds', 'allSitesUsed', 'tpId'],
    components: {

    },
    data: () => ({
        selectedSites: [],
        selectedSitesInOtherThresholdProfiles: [],
        headers: [
            {text: ' ', align: 'start', sortable: true, value: 'selected'},
            {text: 'Site Name', value: 'site_name'},
            {text: 'Office', value: 'site_office'},
            {text: 'Location', value: 'site_location'},
            {text: 'Locale', value: 'site_locale'},
            {text: 'Site Type', value: 'site_type'},
            {text: 'Vendor', value: 'vendor'},
        ],
        footerProps: {
            'items-per-page-options': [50, 100, 250, 500, 100, -1]
        },

        items: [],
        searchText: "",
        filteredItems: []
    }),

    computed: {
        allFilteredItemsSelected() {
            return (this.filteredItems.every(item => {
                return this.selected.some(s => s.value == item.value);
            }));
        },

        matchingResultsText() {
            return (this.allFilteredItemsSelected) ? "Unselect All Matching Results" : "Select All Matching Results";
        },

        filteredItemsIcon() {
            return (this.allFilteredItemsSelected) ? "mdi-checkbox-marked" : "mdi-checkbox-blank-outline";
        },

    },

    methods: {
        inputChanged: function(selectedValues) {
            console.log('selectedValues: ', selectedValues);
            let newSelectedSitesIds = selectedValues.map(s => s.site_id);
            this.$props.allSitesList.forEach(site => {
                if(newSelectedSitesIds.includes(site.site_id)) {
                    site.selected = 'yes';
                }
                else {
                    site.selected = 'no';
                }
            });
            this.$props.selectedSitesIds.splice(0, this.$props.selectedSitesIds.length, ...newSelectedSitesIds); // Doing splice because Vue doesn't like when you mutate props via breaking mem reference. 
        },

        setInputsInitialValue: function() {
            for(let site of this.$props.allSitesList) {
                site.selected = 'no';
                for(let selectedSiteId of this.$props.selectedSitesIds) {
                    if(site.site_id == selectedSiteId) {
                        site.selected = 'yes';
                        this.selectedSites.push(site);
                    }
                }
            }
        },

        setRowColor: function(item) {
            if(this.selectedSitesInOtherThresholdProfiles.includes(item.site_id)) {
                return 'tp-site-used-in-other-tp';
            }
            return '';
        }
    },

    watch: {
    },

    created() {
        for(let tp of this.$props.allSitesUsed) {
            if(tp.id != this.$props.tpId) {
                this.selectedSitesInOtherThresholdProfiles = this.selectedSitesInOtherThresholdProfiles.concat(tp.sites);
            }
        }

        this.$props.allSitesList.forEach(site => {
            site.site_type = (site.data && site.data.site_type) ? site.data.site_type : '';
            site.vendor = (site.data && site.data.vendor) ? site.data.vendor : '';
        })
    },

    mounted() {
        this.setInputsInitialValue();
    }
};
</script>

<style scoped>

    .data-table-container {
        padding: 0px;
        width: 100%;
    }

    .data-table-container .sites-data-table {
        border: solid 1px #303030;
        width: 100%;
        box-shadow: 3px 3px 5px 5px #000000 !important;
    }

</style>

<style>

    .tp-site-used-in-other-tp {
        background-color: rgba(196, 33, 17, 0.3);
    }

</style>
